import { type UIViewInjectedProps, UIView } from '@uirouter/react';
import { Descriptions } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { api } from '@/api';
import { Drawer } from '@/components/drawer';
import { consortiumStore } from '@/stores';
import { getTranslatedString } from '@/utils';

export const ConsortiumView = observer(({ transition }: UIViewInjectedProps) => {
  const consortiumId = +transition.router.globals.params?.consortiumId;
  const consortium = consortiumStore.items.find((item: cyrian.api.consortiums.Consortium) => item.id === consortiumId);

  useEffect(() => {
    if (consortiumId && !consortium) {
      api.consortiums
        .get(consortiumId)
        .source.then(({ data }) => consortiumStore.addItem(data))
        .catch(() => {});
    }
  }, [consortiumId, consortium]);

  const title =
    consortium != null
      ? getTranslatedString('consortiums.consortium-number', { 0: consortium.id })
      : `Consortium #${consortiumId ?? ''}`;

  const onClose = () => {
    transition.router.stateService.go('base-layout.consortiums');
  };

  const cooperativesLabel = consortium?.cooperatives?.map((c) => c.name).join(', ') ?? null;

  return (
    <>
      <Drawer onClose={onClose} visible={true} title={title}>
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label={getTranslatedString('counterparties.name')}>{consortium?.name}</Descriptions.Item>
          <Descriptions.Item label={getTranslatedString('consortiums.cooperatives')}>
            {cooperativesLabel ?? '—'}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
      <UIView />
    </>
  );
});
